import { define, html } from "hybrids";

export interface VBroadcastActions {
  shadow: boolean;
}

export default define<VBroadcastActions>({
  tag: "v-broadcast-actions",
  shadow: false,
  render: ({ shadow }) => html`
    <div id="content">
      ${shadow && html`<div id="shadow"></div>`}
      <slot></slot>
      <div id="info-chat-buttons">
        <slot name="info-chat"></slot>
      </div>
    </div>
  `.css`
    :host {
      position: relative;
      z-index: var(--v-ui-z-index-fixed);
      display: block;
      height: calc(40px + 2 * var(--v-broadcast-layout-spacing) + var(--v-ui-safe-area-inset-bottom));
      box-sizing: border-box;
    }

    #shadow {
      display: none;
    }

    #content {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      will-change: transform;
      display: grid;
      grid-template-columns: 1fr;
      grid-auto-columns: max-content;
      grid-auto-flow: column;
      grid-gap: calc(var(--v-broadcast-layout-spacing) / 2);
      background: rgba(11, 13, 19, 0.9);
      padding: var(--v-broadcast-layout-spacing, 0px);
      padding-bottom: calc(var(--v-ui-safe-area-inset-bottom) + var(--v-broadcast-layout-spacing));
      backdrop-filter: blur(10px) saturate(100%);
      -webkit-backdrop-filter: blur(10px) saturate(100%);
      border-top: 1px solid rgba(128, 129, 145, 0.1);
      height: 40px;
      transition: padding-bottom 0.2s ease-out;
    }
    
    #content > slot {
      display: grid;
      grid-template-columns: 3fr auto;
      gap: 8px;
    }

    #info-chat-buttons {
      display: grid;
      grid-auto-flow: column;
    }

    @media (min-width: 931px) {
      :host {
        height: auto;
      }
    
      #shadow {
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        pointer-events: none;
        height: calc(110px + var(--v-ui-safe-area-inset-bottom));
        background: linear-gradient(180deg, rgba(13, 17, 25, 0) 0%, #080a0e 35%);
      }

      #content {
        position: relative;
        grid-gap: 10px;
        background: none;
        -webkit-backdrop-filter: none;
        backdrop-filter: none;
        padding-bottom: var(--v-broadcast-layout-spacing);
      }
      
      #info-chat-buttons {
        margin-left: 0;
        padding-left: 0;
        border-left: none;
      }
    }
  `,
});
